// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__25lQy","resendInfoText":"OnGoingPaymentBox_resendInfoText__1RFTq"};